<ng-container *ngIf="appData.activeRootMenu === rootMenuEnum.Partner" [ngSwitch]="containerName">
    <ng-container *ngSwitchCase="'partner-dashboard-root'">
        <partner-dashboard-root></partner-dashboard-root>
    </ng-container>

    <ng-container *ngSwitchCase="'merchant-confirm-onboarding'">
        <merchant-confirm-onboarding></merchant-confirm-onboarding>
    </ng-container>

    <ng-container *ngSwitchCase="'merchant-store-onboarding'">
        <merchant-store-onboarding></merchant-store-onboarding>
    </ng-container>
</ng-container>

<p-toast position="top-right"></p-toast>
